import { useGet } from "./hooks";

function ProjectItems() {
  const projectsURL =
    "https://stetor16.dreamhosters.com/wp-json/acf/v3/projects";

  const [data, loading] = useGet(projectsURL);

  return (
    <>
      <div>
        {loading ? (
          "Loading..."
        ) : (
          <div className="projects__items__container">
            {data.map((d) => {
              return (
                <div key={d.id} className="project__items-box pb-5">
                  <p className="site__paragraph">{d.acf.project_title}</p>
                  <p className="site__paragraph">{d.acf.project_subtitle}</p>
                  <div className="project__btn-box">
                    {d.acf.project_files && d.acf.project_files.project_file && (
                      <a
                        target="_blank"
                        href={d.acf.project_files.project_file.url}
                        className="btn btn--white btn--animated m-3"
                      >
                        {d.acf.project_files.project_file.filename}
                      </a>
                    )}

                    {d.acf.project_files &&
                      d.acf.project_files.project_second_file && (
                        <a
                          target="_blank"
                          href={d.acf.project_files.project_second_file.url}
                          className="btn btn--white btn--animated m-3"
                        >
                          {d.acf.project_files.project_second_file.filename}
                        </a>
                      )}
                  </div>
                  <p className="site__paragraph">
                    Description: {d.acf.project_desc}
                  </p>
                  {d.acf.project_image && (
                    <img
                      className="project__publication-img"
                      src={d.acf.project_image.sizes.medium}
                      alt="project__publication-image"
                    />
                  )}
                  {d.acf.project_links_info.project_link.url && (
                    <a
                      target="_blank"
                      className="btn btn--white btn--animated m-3"
                      href={d.acf.project_links_info.project_link.url}
                    >
                      {d.acf.project_links_info.project_link.title}
                    </a>
                  )}
                  {d.acf.project_links_info.project_second_link.url && (
                    <a
                      target="_blank"
                      className="btn btn--white btn--animated m-3"
                      href={d.acf.project_links_info.project_second_link.url}
                    >
                      {d.acf.project_links_info.project_second_link.title}
                    </a>
                  )}
                  {d.acf.co_author && (
                    <p className="site__paragraph">
                      Co-Author: {d.acf.co_author}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
export default ProjectItems;
